import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ToggleService } from '../../template-components/header/toggle.service';
import { AppEnvironmentService } from '../../ui-framework/global-services/app-environment.service';

@Component({
    selector: 'app-confirm-email',
    imports: [RouterLink],
    templateUrl: './confirm-email.component.html',
    styleUrl: './confirm-email.component.scss'
})
export class ConfirmEmailComponent {

    constructor(
        public toggleService: ToggleService,
        private readonly appEnvironmentService: AppEnvironmentService
    ) {}

    ngOnInit(): void {
        // Initialize theme and direction on component load
        this.toggleService.initializeTheme();
    }

    // Toggle theme between light and dark
    toggleTheme() {
        this.toggleService.toggleTheme();
    }

    // Toggle direction between LTR and RTL
    toggleDirection() {
        this.toggleService.toggleDirection();
    }

    get homeRoute(): string {
        return this.appEnvironmentService.isLoggedIn ? '/dashboard' : '/authentication';
    }

}
